import { reducer as activateTag } from './activateTag'
import { reducer as addTag } from './addTag'
import { reducer as deleteTag } from './deleteTag'
import { reducer as getEmployeesByTagId } from './getEmployeesByTagId'
import { reducer as getManagersByTagId } from './getManagersByTagId'
import { reducer as getTag } from './getTag'
import { reducer as getTags } from './getTags'
import { reducer as selectedTag } from './selectedTag'
import { reducer as tagAddModal } from './tagAddModal'
import { reducer as updateTag } from './updateTag'
import { reducer as tagUpdateModal } from './tagUpdateModal'
import { reducer as selectedTagCategory } from './selectedTagCategory'
import { reducer as deletedTagsModal } from './deletedTagsModal'
import { reducer as getDeletedTags } from './getDeletedTags'

export default {
  activateTag,
  addTag,
  deleteTag,
  getEmployeesByTagId,
  getManagersByTagId,
  getTag,
  getTags,
  selectedTag,
  tagAddModal,
  updateTag,
  tagUpdateModal,
  selectedTagCategory,
  deletedTagsModal,
  getDeletedTags
}



// WEBPACK FOOTER //
// ./src/store/tags/index.js